import { useState } from 'react';
import { Link } from 'react-router-dom';
import OverviewTabContent from './components/OverviewTabContent';
import RevenueAnalyticsTabContent from './components/RevenueAnalyticsTabContent';
import ConfigurationTabContent from './components/ConfigurationTabContent';

type MonetizationTab = 'overview' | 'analytics' | 'config';

export default function AdminMonetizationPage() {
  const [activeTab, setActiveTab] = useState<MonetizationTab>('overview');

  const tabs: { key: MonetizationTab; label: string; icon: string; color: string }[] = [
    { key: 'overview', label: 'Overview', icon: 'ri-eye-line', color: 'emerald' },
    { key: 'analytics', label: 'Revenue Analytics', icon: 'ri-bar-chart-2-line', color: 'amber' },
    { key: 'config', label: 'Configuración', icon: 'ri-toggle-line', color: 'rose' },
  ];

  const activeTabConfig = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="min-h-screen bg-background-100">
      {/* Mobile topbar */}
      <header className="lg:hidden sticky top-0 z-30 bg-background-50/98 backdrop-blur-2xl border-b border-background-200 safe-top">
        <div className="flex items-center justify-between px-4 h-14">
          <div className="flex items-center gap-2.5 pl-12">
            <div className={`w-7 h-7 rounded-lg bg-${activeTabConfig.color === 'emerald' ? 'emerald' : activeTabConfig.color === 'amber' ? 'amber' : 'rose'}-500 flex items-center justify-center`}>
              <i className={`${activeTabConfig.icon} text-background-50 text-xs`}></i>
            </div>
            <div>
              <h1 className="text-foreground-950 font-bold text-sm">Monetización</h1>
              <p className="text-foreground-400 text-[9px]">{activeTabConfig.label}</p>
            </div>
          </div>
          <Link to="/" className="flex items-center gap-1.5 text-foreground-500 text-xs hover:text-foreground-700 transition-colors whitespace-nowrap">
            <i className="ri-arrow-left-line text-xs"></i>
            <span className="hidden sm:inline">Volver al sitio</span>
          </Link>
        </div>
      </header>

      <div className="flex">
        <main className="flex-1 min-w-0">
          {/* Desktop toolbar */}
          <div className="hidden lg:flex items-center justify-between h-16 px-8 border-b border-background-200 bg-background-50 sticky top-0 z-20">
            <div>
              <h2 className="text-foreground-950 font-bold text-base">Centro de Monetización</h2>
              <p className="text-foreground-400 text-xs">
                Panel unificado · 4 fuentes de ingreso · Revenue Share 70/30
              </p>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/" className="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-background-100 text-foreground-600 text-xs font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-external-link-line text-xs"></i>
                Ver sitio
              </Link>
            </div>
          </div>

          {/* ── Tabs ── */}
          <div className="px-4 md:px-6 lg:px-8 pt-4 md:pt-6 lg:pt-6">
            <div className="flex items-center bg-background-50 border border-background-200 rounded-2xl p-1 max-w-[560px] mx-auto mb-6">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold cursor-pointer transition-all whitespace-nowrap ${
                    activeTab === tab.key
                      ? 'bg-foreground-950 text-background-50'
                      : 'text-foreground-500 hover:text-foreground-700'
                  }`}
                >
                  <i className={`${tab.icon} text-sm`}></i>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* ── Tab Content ── */}
          <div className="px-4 md:px-6 lg:px-8 pb-8">
            {activeTab === 'overview' && <OverviewTabContent />}
            {activeTab === 'analytics' && <RevenueAnalyticsTabContent />}
            {activeTab === 'config' && <ConfigurationTabContent />}
          </div>
        </main>
      </div>


    </div>
  );
}